(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('PasswordController', PasswordController);

    /** @ngInject */
    function PasswordController ($scope, Auth, Principal, toastr, $translate) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.checkPasswords = checkPasswords;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        $scope.$watch('vm.password', vm.checkPasswords);
        $scope.$watch('vm.confirmPassword', vm.checkPasswords);

        function checkPasswords() {
            if ($scope.form && $scope.form.confirmPassword) {
                if ((vm.password !== vm.confirmPassword) && vm.confirmPassword) {
                    $scope.form.confirmPassword.$setValidity('notEquals', false);
                } else {
                    $scope.form.confirmPassword.$setValidity('notEquals', true);
                }
            }
        }

        function changePassword () {
            if (vm.password === vm.confirmPassword) {
                Auth.changePassword(vm.password).then(function () {
                    toastr.success($translate.instant('password.messages.success'));
                    $scope.form.$setPristine();
                    vm.password = null;
                    vm.confirmPassword = null;
                }).catch(function () {
                    toastr.error($translate.instant('password.messages.error'));
                });
            }
        }
    }
})();
